import { Message } from 'element-ui';
import { fetch } from '../config/fetch.js'

export function toast(str, num, showClose, onClose) {
	if (num == 1) {
		var type = 'success';
	} else if (num == 2) {
		var type = 'error';
	} else if (num == 3) {
		var type = 'warning';
	} else {
		var type = 'info';
	}
	if (showClose) {
		Message({
			showClose: true,
			message: str,
			type: type,
			duration: 3000,
			onClose: onClose
		});
	} else {
		Message({
			showClose: false,
			message: str,
			type: type,
			duration: 1000
		});
	}
}//全局toast方法

export function imageError(num, event) {
	if (num == 1) {
		event.target.src = require("../assets/img/shangpin_moren@2x.png");
	} else if (num == 2) {
		event.target.src = require("../assets/img/shouye_banner_moren@2x.png");
	} else if (num == 3) {
		event.target.src = require("../assets/img/pinpailogo_moren@2x.png");
	} else if (num == 4) {
		event.target.src = require("../assets/img/touxiang_moren@2x.png");
	} else if (num == 5) {
		event.target.src = require("../assets/img/dingbu_banner_moren@2x.png");
	} else if (num == 6) {
		event.target.src = require("../assets/img/huodongshangpin_xinqite_moren@2x.png");
	}
}//全局图片加载失败方法

//返回值：arg1乘以arg2的精确结果
export function accMul(arg1, arg2) {
	var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
	try { m += s1.split(".")[1].length } catch (e) { }
	try { m += s2.split(".")[1].length } catch (e) { }
	return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
}

//返回值：arg1除以arg2的精确结果
export function accDiv(arg1, arg2) {
	var t1 = 0, t2 = 0, r1, r2;
	try { t1 = arg1.toString().split(".")[1].length } catch (e) { }
	try { t2 = arg2.toString().split(".")[1].length } catch (e) { }
	r1 = Number(arg1.toString().replace(".", ""))
	r2 = Number(arg2.toString().replace(".", ""))
	return (r1 / r2) * pow(10, t2 - t1);
	// with (Math) {

	// }
}


//加法   
Number.prototype.add = function (arg) {
	var r1, r2, m;
	try { r1 = this.toString().split(".")[1].length } catch (e) { r1 = 0 }
	try { r2 = arg.toString().split(".")[1].length } catch (e) { r2 = 0 }
	m = Math.pow(10, Math.max(r1, r2))
	return (this * m + arg * m) / m
}
//减法   
Number.prototype.sub = function (arg) {
	return this.add(-arg);
}
//乘法   
export function numberMul(arg1, arg2) {
	return (arg1 * 1000) * (arg2 * 1000) / 1000000; //防止丢失精度
}
//除法   
export function numberDiv(arg1, arg2) {
	return ((arg1 * 1000) / (arg2 * 1000)); //防止丢失精度

} 



// WEBPACK FOOTER //
// ./src/util/tool.js